import React from 'react';

function About() {
  return (
    <div style={{ padding: '20px' }}>
      <h1>About Us</h1>
      <p>Information about our project and team.</p>
    </div>
  );
}

export default About;
